import { BidApi } from '../api-typings/projects/projects';
import { Bid } from './bid.model';

export function transformBid(bid: BidApi): Bid {
  return {
    id: bid.id,
    bidderId: bid.bidder_id,
    projectId: bid.project_id,
    retracted: bid.retracted,
    amount: bid.amount,
    period: bid.period,
    description: bid.description,
    projectOwnerId: bid.project_owner_id,
    submitdate: bid.submitdate,
    // buyerProjectFee?: Fee;
    timeSubmitted: bid.time_submitted,
    highlighted: bid.highlighted,
    sponsored: bid.sponsored,
    milestonePercentage: bid.milestone_percentage,
    awardStatusPossibilities: bid.award_status_possibilities,
    awardStatus: bid.award_status,
    paidStatus: bid.paid_status,
    completeStatus: bid.complete_status,
    timeAwarded: bid.time_awarded,
    frontendBidStatus: bid.frontend_bid_status,
    hiremeCounterOffer: bid.hireme_counter_offer,
    shortlisted: bid.shortlisted,
    score: bid.score,
    // negotiatedOffer?: NegotiatedOfferApi;
    hidden: bid.hidden,
    hiddenReason: bid.hidden_reason,
    timeAccepted: bid.time_accepted,
    paidAmount: bid.paid_amount,
    hourlyRate: bid.hourly_rate,
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/es/webapp/src/app/@shared/datastore/bid/bid.transformers.ts